module.exports = __webpack_public_path__ + "static/media/play-icon.afe1d899.svg";